export const PaymentVendorProcessType = Object.freeze({
    RegularPayment: 1,
    AutoPayment: 2
});